import { mycaCardTypes } from './productMapping';

export const centurionLoungeEligibleCards = [
  mycaCardTypes.centurion,
  mycaCardTypes.deltaReserve,
  mycaCardTypes.platinum,
];

export const waitlistStatus = {
  GET: 'GET',
  JOIN: 'JOIN',
  OFF: 'OFF',
  QUEUEING: 'QUEUEING',
  READY: 'READY',
};

export const WEB = 'WEB';

export const waitlistIconTypes = {
  CLOCK: 'clock',
  QR_SCAN: 'qrScan',
  SUCCESS: 'success',
};

export const WAITLIST_SCROLL_POSITION_KEY = 'wspk';
export const WAITLIST_SCROLL_RESTORE_TTL_MS = 1000 * 60 * 30;
